import src from "IMAGE";
export default { src, width: 1113, height: 376, blurWidth: 8, blurHeight: 3, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAIAAAAhqtkfAAAAPUlEQVR42jXKsQ0AIAhEUQYgNBRUxA6Cwv7reTHxdzyOZqa7q2r/IsLMCA9oZp4X1N1FhDDHsV4gVYUy8wWXmgmy9uMOugAAAABJRU5ErkJggg=="};
